import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";
import { Button } from "./ui/button";
import { EqualNot } from "lucide-react";

export function OverridesButton({ onClick }: { onClick: () => void }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          className="text-orange-500 pb-0 pt-0 mr-auto"
          size="sm"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick();
          }}
        >
          <EqualNot />
          Overrides
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>See domain overrides for this setting.</p>
      </TooltipContent>
    </Tooltip>
  );
}
